import React from "react";
import './index.css';
import Password from "./Password";

function App(){
  return (
    <>
      <div>
        <Password />
      </div>
    </>
  )
}

export default App;